import React from 'react';
import { View } from 'react-native';

import { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { formatOEENumber, convertTimeLetter } from '@helpers';
import { MachineStatisticOEETeep } from '@interfaces/machines';

import Circle from './circle';
import SplitLine from './splitLine';

interface FormulaCirclesProps extends WithColor {
  machineStatistics: MachineStatisticOEETeep;
}

const FormulaCircles = ({ C, machineStatistics }: FormulaCirclesProps) => {
  return (
    <View>
      <View style={{ marginTop: scale(20), justifyContent: 'space-around', flexDirection: 'row' }}>
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/Factor',
            percentage: formatOEENumber((machineStatistics.totalActiveSecs * 100) / machineStatistics.totalScheduledSecs),
            name: 'Active',
            subtitle: '(Availability)',
            timeTop: convertTimeLetter(machineStatistics.totalActiveSecs),
            timeBottom: convertTimeLetter(machineStatistics.totalScheduledSecs),
          }}
        />
        <SplitLine {...{ C, symbol: 'X' }} />
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/Factor',
            percentage: formatOEENumber((machineStatistics.totalPerformanceSecs * 100) / machineStatistics.totalActiveSecs),
            name: 'Ideal Speed',
            subtitle: '(Performance)',
            timeTop: convertTimeLetter(machineStatistics.totalPerformanceSecs),
            timeBottom: convertTimeLetter(machineStatistics.totalActiveSecs),
          }}
        />
        <SplitLine {...{ C, symbol: 'X' }} />
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/Factor',
            percentage: formatOEENumber((machineStatistics.totalQualitySecs * 100) / machineStatistics.totalPerformanceSecs),
            name: 'Good Production',
            subtitle: '(Quality)',
            timeTop: convertTimeLetter(machineStatistics.totalQualitySecs),
            timeBottom: convertTimeLetter(machineStatistics.totalPerformanceSecs),
          }}
        />
        <SplitLine {...{ C, symbol: '=' }} />
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/OEE',
            percentage: formatOEENumber((machineStatistics.totalQualitySecs * 100) / machineStatistics.totalScheduledSecs),
            name: 'OEE',
            timeTop: convertTimeLetter(machineStatistics.totalQualitySecs),
            timeBottom: convertTimeLetter(machineStatistics.totalScheduledSecs),
          }}
        />
      </View>

      <View style={{ marginTop: scale(57), flexDirection: 'row', justifyContent: 'space-around' }}>
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/OEE',
            percentage: formatOEENumber((machineStatistics.totalQualitySecs * 100) / machineStatistics.totalScheduledSecs),
            name: 'OEE',
            timeTop: convertTimeLetter(machineStatistics.totalQualitySecs),
            timeBottom: convertTimeLetter(machineStatistics.totalScheduledSecs),
          }}
        />
        <SplitLine {...{ C, symbol: 'X' }} />
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/All Time',
            percentage: formatOEENumber((machineStatistics.totalScheduledSecs * 100) / machineStatistics.totalDurationSecs),
            name: 'Productive',
            subtitle: '(Availability)',
            timeTop: convertTimeLetter(machineStatistics.totalScheduledSecs),
            timeBottom: convertTimeLetter(machineStatistics.totalDurationSecs),
          }}
        />
        <SplitLine {...{ C, symbol: '=' }} />
        <Circle
          {...{
            C,
            backgroundColor: 'OEE/Light/TEEP Chart',
            percentage: formatOEENumber((machineStatistics.totalQualitySecs * 100) / machineStatistics.totalDurationSecs),
            name: 'Net Utilization',
            subtitle: '(TEEP)',
            timeTop: convertTimeLetter(machineStatistics.totalQualitySecs),
            timeBottom: convertTimeLetter(machineStatistics.totalDurationSecs),
          }}
        />
      </View>
    </View>
  );
};

export default FormulaCircles;
